/**
 * Resolves per-pack / line price from medicine search API fields.
 * Prefer salePrice (e.g. strip MRP), then rate/medicineRate, then unitPrice.
 */
export function getMedicineDisplayPrice(item) {
  if (!item) return null;

  const salePrice = Number(item.salePrice);
  if (!Number.isNaN(salePrice) && salePrice > 0) return salePrice;

  const rate = Number(item.rate ?? item.medicineRate);
  if (!Number.isNaN(rate) && rate > 0) return rate;

  const unitPrice = Number(item.unitPrice);
  if (!Number.isNaN(unitPrice) && unitPrice > 0) return unitPrice;

  return null;
}

export function formatMedicinePriceAmount(price) {
  if (price == null || price === "") return null;
  const num = Number(price);
  if (Number.isNaN(num)) return null;
  return Number.isInteger(num) ? num : Number(num.toFixed(2));
}
